import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  userId: string | null;
  username: string | null;
  userType: string | null;
  firstName: string | null;
  lastName: string | null;
  bankName: string | null;
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  userId: null,
  username: null,
  userType: null,
  firstName: null,
  lastName: null,
  bankName: null,
  token: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<{
      userId: string;
      username: string;
      userType: string;
      firstName: string;
      lastName: string;
      bankName: string | null;
      token: string;
    }>) => {
      state.userId = action.payload.userId;
      state.username = action.payload.username;
      state.userType = action.payload.userType;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.bankName = action.payload.bankName;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      
      console.log('✅ Redux Auth Data Set:', {
        userId: state.userId,
        username: state.username,
        userType: state.userType,
        bankName: state.bankName
      });
    },
    clearAuthData: (state) => {
      state.userId = null;
      state.username = null;
      state.userType = null;
      state.firstName = null;
      state.lastName = null;
      state.bankName = null;
      state.token = null;
      state.isAuthenticated = false;
      
      console.log('🔒 Redux Auth Data Cleared');
    },
  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;

